export default __webpack_public_path__ + "static/media/yubi-big.2aff29cf.svg";